<div class="content space-y-4">
    <div class="flex justify-between items-center">
        <div class="flex items-center gap-2 text-lg font-semibold text-primary-500">
            <fa-icon [icon]="faBoxesStacked" class="text-primary-500 text-xl"></fa-icon>
            <span>สต๊อกสินค้า</span>
            <span class="label !text-xs"
                [ngClass]="branchMode ? 'label-primary' : 'label-secondary'">
                {{ branchMode ? 'สาขา' : 'สำนักงานใหญ่' }}
            </span>
        </div>
        <div class="">
            @if(!branchMode && canAccess()){
            <button class="btn-sm btn-primary" (click)="openSyncProductDialog()">ซิงค์รายการสินค้า</button>
            }
        </div>
    </div>
    <div class="card">
        <form [formGroup]="form" class="grid grid-cols-2 md:grid-cols-4 gap-4">
            @if (branchMode) {
            <div class="w-full">
                <label class="text-sm">สาขา</label>
                <div class="relative w-full">
                    <input type="text" class="input" placeholder="ค้นหาสาขา"
                        [(ngModel)]="branchKeyword" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="filterBranches()" (focus)="openBranchFilter()"
                        (blur)="closeBranchFilter()">
                    <ul class="absolute z-50 w-full !rounded-lg bg-white mat-elevation-z8 max-h-72 overflow-y-auto top-11 py-2"
                        *ngIf="showBranchFilter && branchesFilter.length > 0">
                        <li *ngFor="let branch of branchesFilter"
                            class="min-h-[40px] hover:bg-secondary-100 hover:cursor-pointer flex items-center px-3 py-2 text-sm"
                            [ngClass]="{'bg-primary-50 font-semibold': branch.shop_ref === channelSelected}"
                            (mousedown)="selectBranch(branch)">
                            <span class="inline-block w-2 h-2 rounded-full mr-2 shrink-0"
                                [style.background-color]="branch.color || '#32436a'"></span>
                            <span class="truncate">{{branch.platform_name}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            }
            <div class="w-full">
                <label class="text-sm">สินค้า</label>
                <input class="input" type="text" placeholder="กรอกชื่อ/รหัสสินค้า" formControlName="keyword">
            </div>
            <div class="">
                <label class="text-sm">หมวดหมู่</label>
                <mat-form-field class="w-full">
                    <mat-select class="" placeholder="เลือกหมวดหมู่" formControlName="category_id">
                        <mat-option value="">ทั้งหมด</mat-option>
                        @for (item of categories; track $index) {
                        <mat-option [value]="item.id">{{item.name}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            @if (!branchMode) {
            <div class="">
                <label class="text-sm">จำนวนในคลัง</label>
                <div class="flex gap-2 items-center">
                    <input class="input" type="number" placeholder="ต่ำสุด" formControlName="min_stock">
                    <div class="">-</div>
                    <input class="input" type="number" placeholder="สูงสุด" formControlName="max_stock">
                </div>
            </div>
            }
            <button class="btn-sm btn-primary w-fit self-end" (click)="submitForm()">ค้นหา</button>
        </form>
    </div>
    @if(loading){
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <app-loader></app-loader>
            <div class="font-medium">Loading</div>
        </div>
    </div>
    }
    @if (!loading && datasets.length === 0) {
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <div class="h-32">
                <img src="assets/images/web_20.png" alt="" class="h-full">
            </div>
            <div class="font-medium">Data Not Found</div>
        </div>
    </div>
    }
    @else if (!loading && datasets.length > 0){
    <div class="card">
        <div>
            <div class="div-table">
                <table>
                    <thead>
                        <tr class="thead-tr divide-x">
                            <th class="text-left">
                                สินค้า
                            </th>
                            <th class="text-center">
                                {{ branchMode ? 'สต๊อกสำนักงาน' : 'จำนวนในคลัง' }}
                            </th>
                            @if (branchMode) {
                            <th class="text-center">
                                สต๊อก Sabuysoft
                            </th>
                            }
                            @for (channelsHeader of channelsHeaders; track $index) {
                            <th>
                                {{channelsHeader}}
                            </th>
                            }
                            @if (!branchMode) {
                            <th class="text-center">
                                จัดการ
                            </th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of datasets; track $index) {
                        <tr class="tbody-tr divide-x">
                            <td class="">
                                <div class="flex items-center">
                                    <img [src]="'https://storage.maxxgadget.com/img/product/' + row.sku + '/1.jpg'"
                                        alt="" class="flex-none w-8 h-8 mr-2"
                                        onerror="this.onerror=null; this.src='assets/images/warranty.png'">
                                    <div class="w-full flex flex-col truncate">
                                        <span class="w-full truncate whitespace-nowrap">{{ row.name }}</span>
                                        <div class="flex gap-2 items-center">
                                            <span class="text-xs pr-2 text-blue-500">{{row.sku}}</span>
                                            <span class="label label-primary">{{row.category.name}}</span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center w-36" [ngClass]="{'text-red-500':row.in_stock===0}">
                                {{row.in_stock | number}}
                            </td>
                            @if (branchMode) {
                            <td class="text-center w-36"
                                [class.bg-red-50]="row.stockMismatch"
                                [ngClass]="{'text-lime-500': row.branch_stock>0, 'text-red-500': row.branch_stock<=0}">
                                {{row.branch_stock | number}}
                            </td>
                            }
                            @for (channelsHeader of channelsHeaders; track $index) {
                            <td class="text-left border-r w-36"
                                [class.bg-red-50]="row.stockMismatch && channelsHeader === row.mismatchPlatform">
                                <div class="space-y-2 w-36">
                                    @for (product of getStockByPlatform(channelsHeader, row.stocks); track $index) {
                                    <div class="flex justify-center items-center w-full"
                                        [matTooltip]="getTooltipText(product)" matTooltipClass="!w-44 whitespace-pre-line text-le">
                                        <div class="flex items-center">
                                            <div class="text-gray-500 text-xs pr-2 truncate">
                                                <span>{{product.channel_name}}:</span>
                                            </div>
                                        </div>
                                        <div class="font-semibold text-primary-500"
                                            [ngClass]="{'text-red-500':product.sellable===0}">{{product.sellable}}</div>
                                    </div>
                                    }
                                </div>
                            </td>
                            }
                            @if (!branchMode) {
                            <td class="w-44">
                                <div class="flex justify-center w-44">
                                    <button class="btn-sm btn-light" (click)="openUpdateStockDialog(row.sku)"
                                        [disabled]="row.stocks.length <= 0">อัพเดตสต๊อก</button>
                                </div>
                            </td>
                            }
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
            <app-pagination [callBackPageChange]="callBackPageChange" [pageSize]="pageSize" [pageIndex]="pageIndex"
                [length]="countDataSource"></app-pagination>
        </div>
    </div>
    }
</div>
